<template>
    <div class="gray-bg">
        <div class="center clearfix">
            <leftNav :selected="leftnav"></leftNav>
            <div class="content">
                <div class="content-title">
                    <h5>基本信息</h5>
                </div>
                <form name="form" class="form"  action="">
                    <h6 class="dataTitle">账号信息</h6>
                    <table width="100%" class="from-table">
                        <tr>
                            <td width="15%">
                                <label for="nickname">昵称</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="nickname" required v-model='Customer.name'>
                            </td>
                            <td width="15%">
                                性别
                            </td>
                            <td width="35%">
                                <label class="radio-label"><input name="sex" type="radio" value="男" v-model='Customer.gender' />男 </label> 
                                <label class="radio-label"><input name="sex" type="radio" value="女" v-model='Customer.gender' />女</label> 
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                                头像
                            </td>
                            <td width="35%" class="from-img-box">
                                <Headshot v-on:FaceImg="faceImg" :Face="Customer.face"></Headshot>
                            </td>
                            <td width="15%">
                                <label for="job">职业</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="job" required v-model='Customer.vocation'>
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                                地区
                            </td>
                            <td width="35%" colspan="3">
                                <Site v-on:DeparTure="deparTure"></Site>
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                                <label for="signature">签名</label>
                            </td>
                            <td width="35%" colspan="3">
                                <textarea class="from-textarea" id="signature" rows="3" required v-model='Customer.sign'></textarea>
                            </td>
                        </tr>
                    </table>
                    <h6 class="dataTitle">实名信息 </h6>
                    <table width="100%" class="from-table">
                        <tr>
                            <td width="15%">
                                <label for="name">真实姓名</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="name" required v-model='Customer.trueName'>
                            </td>
                            <td width="15%">
                                证件类型
                            </td>
                            <td width="35%">
                                <select class="from-input " required v-model="Customer.cardType">
                                    <option disabled selected value="">请选择</option>
                                    <option v-for="(item,index) in certificateType" :value="item">{{item}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                            <label for="Birthday"> 出生年份</label>
                            </td>
                            <td width="35%" colspan="3">
                                <input type="text" class="from-input" id="Birthday" required v-model='Customer.birthday'>
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                                证件照片
                            </td>
                            <td width="35%" class="from-img-box">
                                <label class="file-label" for="pictures">点击上传证件照片</label>
                                <input autocomplete="off" type="file" accept="image/png, image/jpeg, image/jpg" id="pictures" class="from-file" @change="Picture($event)" required>
                                <label class="img-label" for="pictures">
                                    <img class="from-img2" :src="Pictures"/>
                                </label>
                            </td>
                            <td width="15%">
                                <label for="Number">证件号码</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="Number" required v-model='Customer.cardId'>
                            </td>
                        </tr>
                        
                    </table>
                    <div class="clearfix"><button class="btn BtnForm" @click="submitPro">下一步</button></div>
                    
                </form>
            </div>
        </div>
        
    </div>
</template>
<script>
import leftNav from '@/components/public/leftNav'
import Headshot from '@/components/public/headshot'
import Site from '@/components/public/site'
import data from '@/assets/css/data.scss'

export default {
    name: 'information',
    data () {
        return {
            sendSelected:'',
            colourClass:'white',
            leftnav:'information',
            session:'',
            City:'', // 地
            Path:'', // 路径
            certificateType:[ '身份证','护照'],
            // Certificate:'身份证',
            Pictures:'',
            PicturesFile:'',
            face:'',//头像
            Customer:{
                name:'',//昵称
                gender:'', //性别
                vocation:'',//职业
                region:'',//地区
                path:'',//地区路径
                sign:'',//签名
                trueName:'',//姓名
                cardType:'',//证件类型
                birthday:'',//出生年份
                coImage:'',//证件照片数
                cardId:'',//证件号码
                face:'',//头像
                mcontentImage:'',//证件照片
            }
        }
    },
    computed:{
        CustomerApplyView(){ // 获取
            return this.$store.state.interface.gwCustomerApplyView;
        },
        ApplyThree(){ // 提交
            return this.$store.state.interface.gwApplyThree;
        },
        customerSetAvater(){ // 头像
            return this.$store.state.interface.customerSetAvater;
        },
        fileUpload(){ // 头像
            return this.$store.state.interface.fileUpload;
        },
        
    },
    methods:{
		// 地区
        deparTure: function(msg,path){
            this.Customer.region=msg;
            this.Customer.path=path;
        },
        faceImg: function(msg){
            var self = this;
            this.face=msg;
            event.preventDefault();
            var sessionId = JSON.parse(this.session).sourceType;
            var id = JSON.parse(this.session).id;
            let formData = new FormData();
                formData.append('file', self.face);
                formData.append('app', 'liexing');
                formData.append('platform', 'web');
                formData.append('ver', 3);
                formData.append('sid', sessionId);
                // formData.append('id', id);
            let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
            }
            self.$ajax.post(self.customerSetAvater,formData).then(function(res) {
                if(res.data.code == '10000' ){
                    self.$layer.msg('头像上传成功！');
                    return;
                }else{
                    self.$layer.msg('头像上传失败！请刷新后重新操作');
                }
            },function(res) {
                self.$layer.msg('头像上传失败！请刷新后重新操作');
            });
        },
        Picture(event){ //图片添加
            let file = event.target.files[0],
            reader = new FileReader(),
            formData = new FormData(),
            value = event.target.value,
            self = this;
            if(file){
                if (/^image\/png/.test(file.type) || /^image\/jpeg/.test(file.type)){
                // self.file=file;
                    reader.onload = function(e){ 
                        let result = e.target.result;
                        $(event.target).siblings('.img-label').show().siblings('.file-label').hide();
                        value = '';
                        self.Pictures=result;
                        self.PicturesFile=file; 
                        self.Customer.coImage=1;
                        // if(self.imgList.length<1){
                        //     if(self.imgList.indexOf(result) == -1){ 
                        //         self.imgList.push(result);
                        //         value = '';
                        //         self.file=file;
                        //         // console.log(self.imgList)
                        //         // self.thenewproduct.coImage=self.imgList.length;
                        //     }else{// 已存在
                        //         self.$layer.msg('图片已存在！');
                        //     }
                        // }else{
                        //     self.$layer.msg('主图限制9张以内！');
                        // }
                        
                    }

                    reader.readAsDataURL(file);

                // formData.append('file', e.target.files[0]);
                // formData.append('type', 'test');
                }else if(/^image\/gif/.test(file.type)){
                    self.$layer.msg('不支持的图片格式！');
                }else{
                    self.$layer.msg('该文件不是图片！');
                }    
            }else{//没有选
                return;
            }
        },
        submitPro(){
            var self = this;
            event.preventDefault();
            // 判断参数不能为空
            var Value = false;
            $('.from-input').each(function(){
                if(this.value == ''){
                    Value = false;
                    return;
                }else{
                    Value = true;
                }
            });

            if(self.Customer.region == ''){
                Value = false;
                self.$layer.msg('请把地址填写完整！');
                return;
            }else if(self.Customer.coImage == ''){
                Value = false;
                self.$layer.msg('请上传证件照片！');
                return;
            }else if(self.Customer.face == ''){
                Value = false;
                self.$layer.msg('请上传头像！');
                return;
            }else if(self.Customer.gender == ''){
                Value = false;
                self.$layer.msg('请选择性别！');
                return;
            }else if(self.Customer.cardType == ''){
                Value = false;
                self.$layer.msg('请选择证件类型！');
                return;
            }else if(self.Customer.sign == ''){
                Value = false;
                self.$layer.msg('请填写签名！');
                return;
            }else{
                Value = true;
            }

            if(Value == false){
                self.$layer.msg('请把信息填写完整！');
                return;
            }

            var sessionId = JSON.parse(this.session).sourceType;
            var id = JSON.parse(this.session).id;

            // 图片提交
            if(self.PicturesFile != ''){
                let formData1 = new FormData();
                    formData1.append('file', this.PicturesFile);
                    formData1.append('coImage', this.Customer.coImage);
                    formData1.append('sourceType', 'CustomerCertify');
                    formData1.append('sid', sessionId);
                    formData1.append('sourceId', id);
                    formData1.append('app', 'liexing');
                    formData1.append('platform', 'web');
                    formData1.append('ver', 3);
                    // console.log(this.Customer.coImage);
                let config = {
                      headers: {
                        'Content-Type': 'multipart/form-data'
                      }
                }
                self.$ajax.post(self.fileUpload,formData1,config).then(function(res2) {
                    if(res2.data.code == '10000' ){
                        self.$layer.msg('证件照片上传成功！');
                        return;
                    }else{
                        self.$layer.msg('证件照片上传失败！');
                    
                    }
                },function(res2) {
                    self.$layer.msg('证件照片上传失败！');
                });
            }
            let formData = new FormData();
                formData.append('name', self.Customer.name);
                formData.append('gender', self.Customer.gender);
                formData.append('vocation', self.Customer.vocation);
                formData.append('region', self.Customer.region);
                formData.append('path', self.Customer.path);
                formData.append('sign', self.Customer.sign);
                formData.append('trueName', self.Customer.trueName);
                formData.append('cardType', self.Customer.cardType);
                formData.append('birthday', self.Customer.birthday);
                formData.append('coImage', self.Customer.coImage);
                formData.append('cardId', self.Customer.cardId);
                formData.append('app', 'liexing');
                formData.append('platform', 'web');
                formData.append('sid', sessionId);
                
            self.$ajax.post(self.ApplyThree,formData).then(function(res) {
                if(res.data.code == '10000' ){
                    self.$layer.msg('提交成功');
                    if(self.sendSelected=='cooperation'){
                        self.$router.push({ path: '/cooperation/authentication' })
                    }else if(self.sendSelected=='league'){
                        self.$router.push({ path: '/league/authentication' })
                    }
                }else if(res.data.code == '14001' ){
                    self.$layer.msg('个⼈资料参数错误');
                }else if(res.data.code == '14002' ){
                    self.$layer.msg('实名信息参数错误');
                }else{
                    self.$layer.msg('提交失败');
                }
            },function(res) {
                self.$layer.msg('提交失败');
            });
        },
        UrlPath(){
            var Url = window.location.href;
            var UrlPath=Url.split('/');
            for(var i in UrlPath){
                if(UrlPath[i]=='cooperation'){
                    this.sendSelected='cooperation';
                }else if(UrlPath[i]=='league'){
                    this.sendSelected='league';
                }
            }
        }
    },
    beforeMount(){
        var self= this;
        var url = this.CustomerApplyView;
        this.session=sessionStorage.getItem('GWcustomer');

        this.UrlPath() // 路径判断达人还是供应商
        if(this.session==null){
            if(self.sendSelected=='cooperation'){
                self.$router.push({ path: '/cooperation' })
            }else if(self.sendSelected=='league'){
                self.$router.push({ path: '/league' })
            }
        }
        
        var sessionId = JSON.parse(this.session).sourceType;
        this.$ajax.post(url+'?sid='+sessionId).then(function(res){
            
            if(res.data.code == '10000'){
                self.Customer= res.data.result.GwCustomer;
                if(self.Customer.birthday==0){
                    self.Customer.birthday='';
                }
                if(self.Customer.mcontentImage!=''){
                    self.Pictures=self.Customer.mcontentImage;
                    $('#pictures').siblings('.img-label').show().siblings('.file-label').hide();
                }
                if(self.Customer.face!=''){
                    
                }
            }else{
                self.$layer.msg('资料获取失败');
            }
        },function(res){
            self.$layer.msg('资料获取失败');
        })
    
        
    },
    mounted(){
        this.UrlPath() // 路径判断达人还是供应商
        this.$emit('nav',this.sendSelected,this.colourClass);
    },
    components:{
        leftNav,
        Headshot,
        Site,
    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/cooperation/information.vue